import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import QRCode from "react-qr-code";
import StudentInfo from '../FeeSystem/StudentInfo';
import moment from "moment";
import PrintHeader from '../General/PrintHeader';
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from '../General/Utility';
import { scrollToTop } from '../Shared/ScrollOnTop';

const StudentFinePrint = () => {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [ReportMonth, setReportMonth] = useState("");
    const [ReportYear, setReportYear] = useState("");
    const [Session, setSession] = useState("");
    const [Class, setClass] = useState("");
    const [Wing, setWing] = useState("");
    const [Section, setSection] = useState("");
    const [OrderBy, setOrderBy] = useState("");

    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);



    useEffect(() => {
        document.title="Student Fine Print"

        setLoading(true);
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const ReportMonth = urlParams.get('ReportMonth');
        const fineAmount = urlParams.get('FineAmount');
        const Wing = urlParams.get('Wing_Id');
        const Class = urlParams.get('Class_Id');
        const Section = urlParams.get('Section_Id');
        const PaidStatus = urlParams.get('PaidStatus');
        const OrderBy = urlParams.get('OrderBy');

        setReportYear(ReportYear);
        setReportMonth(ReportMonth);

        const data = {
           AccessKey: AccessKey,
            UserID: UserID,
MemberType: MemberType,
            pageNo: pageNo,
            pageSize: 1000,
            ReportMonth: ReportMonth,
            FineAmount: fineAmount,
            Wing_Id: Wing,
            Class_Id: Class,
            Section_Id: Section,
            PaidStatus: PaidStatus,
            OrderBy: OrderBy,
        };

        //console.log(data);

        var api_config = {
            method: 'post',
            url: config.base_url + '/Reports/GetStudentsFineReport',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        //console.log(data);
        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);
                setTotalRecords(response.data.totalRecords);
                setTotalAmount(response.data.TotalAmount);

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, []);

    const renderLedger = () => {

        if (listOfLedger.length > 0) {
            let count = 1;
            let countbreak = 1;
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}
                        //  className={countbreak++ == 40 ? 'page-break' : ''}
                         >
                            <td>{count++ + (pageSize * (pageNo - 1))}</td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Father_Name}</td>
                            <td></td>
                            <td>{item.Class_Name}</td>
                            <td>{item.Section_Name}</td>
                            <td>{item.Current_Balance}</td>
                        </tr>

                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colspan="20"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    return (
        <>
            <Page orientation="portrait" size="a4">
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <th colspan={20}>
                                <PrintHeader title={`List of Defaulter Students for the month of ${getMonthName(ReportMonth)} ${ReportYear} `} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading ?
                                <tr>
                                    <td className="text-center" colspan="8">
                                        <Spinner animation="border" role="status"></Spinner>
                                    </td>
                                </tr>
                                :
                                <>
                                    <tr>
                                        <th className="text-end" colSpan={8}>Total Amount:  {calculateColumnTotal(listOfLedger, 'Current_Balance')}</th>
                                    </tr>

                                    <tr>
                                        <th>Sr.#</th>
                                        <th style={{width:"105px"}}>Code #</th>
                                        <th  style={{width:"180px"}}>Student's Name</th>
                                        <th  style={{width:"180px"}}>Father's Name</th>
                                        <th  style={{width:"105px"}}>Contact #.</th>
                                        <th>Class Name</th>
                                        <th>Section Name</th>
                                        <th>Amount</th>
                                    </tr>
                                    {renderLedger()}
                                </>

                        }

                    </tbody>
                </table>
            </Page >
        </>
    );
}

export default StudentFinePrint;
